import React, { FC, useEffect, useState } from 'react';
import { Channel } from 'pusher-js';
import { Header } from '../../commons/Header';
import Footer from '../../commons/Footer/Footer';
import { LocalStorageItems, WsEvents } from '../../../models/Common';
import { NotificationsApi } from '../../../models/PushNotification';
import { useAppDispatch, useAppSelector } from '../../../hooks/redux';
import { ParentModalWindow } from '../../commons/modals';
import { modalSlice } from '../../../store/reducers/ModalSlice';
import { userInfoSlice } from '../../../store/reducers/UserInfoSlice';
import Wss from '../../../core/pusher/Pusher';
import { parseJwt } from '../../../utils';

interface AppLayoutProps extends NotificationsApi {
  children: JSX.Element[];
}

export const AppLayout: FC<AppLayoutProps> = ({ children, ...props }) => {
  const [channel, setChannel] = useState<Channel>();
  const { isAuth } = useAppSelector((state) => state.authReducer);
  const modal = useAppSelector((state) => state.modalReducer);
  const dispatch = useAppDispatch();
  const { closeModal } = modalSlice.actions;
  const { updateUserBalance } = userInfoSlice.actions;

  const listenBalanceChange = () => {
    const token = localStorage.getItem(LocalStorageItems.AccessToken);
    if (!token) return;
    const { sub } = parseJwt(token);
    const pusher = Wss.getInstance();
    setChannel(pusher.subscribe(`customer.${sub}`));
  };

  useEffect(() => {
    if (!channel) {
      return undefined;
    }
    const handleBalanceChanged = (data) => {
      dispatch(updateUserBalance(data));
    };
    channel.bind(WsEvents.BalanceChanged, handleBalanceChanged);

    return () => {
      channel.unbind(WsEvents.BalanceChanged, handleBalanceChanged);
    };
  }, [channel, dispatch, updateUserBalance]);

  useEffect(() => {
    if (isAuth && !channel) {
      listenBalanceChange();
    } else if (!isAuth && channel) {
      Wss.getInstance().unsubscribe(channel.name);
      setChannel(undefined);
    }
  }, [isAuth, channel]);

  const handleCloseModal = () => {
    dispatch(closeModal());
  };

  return (
    <div className="app-layout">
      <Header {...props} />
      <main>{children}</main>
      <Footer />
      <ParentModalWindow
        isOpen={modal.isOpen}
        handleClose={handleCloseModal}
        variant={modal.variant}
        modalContent={modal.content ?? null}
      />
    </div>
  );
};
